// extracted by mini-css-extract-plugin
module.exports = {"kitB":"kitB_kitB__wQUgj"};